import { Link } from "shared/components/Link";
import { AppRoute } from "../../constants";
import IEC608705104Server from "../../images/systemComponents/IEC608705104Server.svg";
import Layout from "../../components/mainPage/Layout";
import { ZoomImageContainer } from "shared/components/Parameters";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 60870-5-104 (Сервер)
                </h1>
                <div className=" w-100 align-start ">
                    <p >
                        <b>Сервер МЭК 60870-5-104</b>  в SCADA NPT Expert обеспечивает передачу технологической информации с объекта автоматизации в диспетчерские центры (в ЦУС, в АО «СО ЕЭС») или другие автоматизированные системы (такие как <Link className="text-links" to={`https://scada-npt-compact.ru/rpamonitorintegration`}>АСМ РЗА</Link>) средствами телемеханики по протоколу МЭК 60870-5-104. Сбор данных осуществляется с помощью клиента МЭК 60870-5-104 или других промышленных протоколов обмена данными.
                    </p>
                    <div style={{ float: 'right' }}>
                        <div style={{ maxWidth: '500px' }}>
                            <ZoomImageContainer
                                image={IEC608705104Server}
                            />
                            {/* <img
                                src={IEC608705104Server}

                                className="mb-4 w-100 "
                                alt="IEC608705104 Сервер"
                            /> */}
                        </div>
                    </div>
                    <div>
                        <p>Передача данных с подстанции в диспетчерские центры по протоколу МЭК 60870-5-104 используется для обеспечения эффективного управления, мониторинга и контроля энергосистемы. Этот протокол является стандартом для телемеханических систем в энергетике и обеспечивает надежную связь между удаленными объектами (например, подстанциями) и центрами управления (диспетчерскими центрами). </p>
                        <p>
                            Основные цели передачи данных по протоколу МЭК 60870-5-104 включают:
                        </p>
                        <ul className="mb-4 description__list">

                            <li className="mb-1 description__number-li">Сбор данных о текущем состоянии оборудования подстанции, таких как:
                                <ul>
                                    <li>Положение выключателей и разъединителей.</li>
                                    <li>Состояние релейной защиты и автоматики.</li>
                                    <li>Аварийные сигналы и предупреждения.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">Сбор измеряемых параметров, таких как:
                                <ul>
                                    <li>Напряжение, ток, активная и реактивная мощность.</li>
                                    <li>Частота, уровень нагрузки, температура трансформаторов.</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">Передача команд от диспетчерского центра на подстанцию для:
                                <ul>
                                    <li>Включения/отключения коммутационных аппаратов.</li>
                                    <li>Изменения уставок релейной защиты.</li>
                                    <li>Переключение режимов работы оборудования.</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>

            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'МЭК 60870-5-104 (Сервер)',
    description: 'Сервер МЭК 60870-5-104  в SCADA NPT Expert обеспечивает передачу технологической информации с объекта автоматизации в диспетчерские центры (в ЦУС, в АО «СО ЕЭС») или другие автоматизированные системы (такие как АСМ РЗА) средствами телемеханики по протоколу МЭК 60870-5-104. Сбор данных осуществляется с помощью клиента МЭК 60870-5-104 или других промышленных протоколов обмена данными.'
}